import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: '',
  fetchOptions: {
    credentials: 'same-origin',
  },
});

export const { signIn, signUp, signOut, useSession } = authClient;
